export const sidebarContainerId = 'catalogSidebarContainer';
export const sidebarContentId = 'catalogSidebarContent';
export const contentContainerId = 'catalogContent';
